


















































































import { Component, Vue } from 'vue-property-decorator'
import { Result } from '../../modules/class/RegisterResponseInfo'
import ErrorFormResponse from '../../modules/class/ErrorFormResponse'
import PathUtil from '../../modules/util/PathUtil'
import JsonUtil from '../../modules/util/JsonUtil'
import axios from 'axios'
import { membershipState } from '../../store/modules/MembershipState'

@Component
export default class RegisterAuthCode extends Vue {
  // --------------------------------------------------------------------------------------------------------------------
  // data
  private authCode = ''
  private result: Result = 'error'
  private resultError: ErrorFormResponse = {}
  private haserror = false
  private isSuccessful = false
  private isAuthCodeModalVisible = false

  // --------------------------------------------------------------------------------------------------------------------
  // Props

  get isLogin(): boolean {
    // membershipState.isLogin
    let loginFlag = membershipState.isLogin
    // ログインパラメータ
    if (this.$route.query.action) {
      const result = this.$route.query.action as string
      loginFlag = result === 'signin'
    }
    return loginFlag
  }

  // -------------------------------------------------------------------------------------------------------------------
  // hocks
  private created() {
    // 会員登録結果パラメータ
    if (this.$route.query.create) {
      const result = this.$route.query.create as string
      this.isAuthCodeModalVisible = result === 'Success'
    }
  }

  // -------------------------------------------------------------------------------------------------------------------
  // methods

  private clearelemnt() {
    this.authCode = ''
    this.resultError = {}
    this.haserror = false
  }

  private close() {
    this.clearelemnt()
    this.isAuthCodeModalVisible = false
    this.isSuccessful = false
  }

  /**
   * submitクリック
   */
  private async checkAuthCode() {
    const form = JSON.stringify({
      auth_code: this.authCode
    })
    const res = await axios.post(
      PathUtil.makePath('/member/api/entry_finish'),
      form
    )
    if (res === undefined || res.status !== 200) {
      // システムエラー
      return
    }
    this.result = res.data.result
    if (this.result === 'success') {
      // success entry finish
      this.isSuccessful = true
      this.isAuthCodeModalVisible = false
    } else {
      // show error message
      this.resultError = JsonUtil.jsonToObject<ErrorFormResponse>(
        ErrorFormResponse,
        res.data.errordata || {}
      )
      this.haserror = false
      if (this.resultError.common !== undefined) {
        this.haserror = true
      }
    }
  }
}
